// extracted by mini-css-extract-plugin
module.exports = {"group":"input-group_group__ynEzF","forceMobile":"input-group_forceMobile__82IVW"};